import { useMemo } from "react";
import { MoneyDirection } from "@common/constants";
import { FiltersTypes } from "@common/types/filters/general";

export interface DocumentAnchoredSearch {
    transactionDirection: MoneyDirection;
    suggestedForInvoiceId?: string;
}

export function getIsSearchModePickerVisible(
    documentAnchoredSearch: DocumentAnchoredSearch | undefined,
): boolean {
    return (
        documentAnchoredSearch === undefined ||
        documentAnchoredSearch.suggestedForInvoiceId !== undefined
    );
}

export function toInvoiceSuggestionFilters({
    search,
    entityIds,
}: Partial<FiltersTypes>): Pick<Partial<FiltersTypes>, "search" | "entityIds"> {
    return { search, entityIds };
}

export function useDocumentAnchoredSearchFilters({
    documentAnchoredSearch,
    sourceTransactionAmount,
    filters,
}: {
    documentAnchoredSearch: DocumentAnchoredSearch | undefined;
    sourceTransactionAmount: number;
    filters: Partial<FiltersTypes>;
}) {
    const transactionDirection =
        documentAnchoredSearch?.transactionDirection ??
        (sourceTransactionAmount > 0
            ? MoneyDirection.MONEY_OUT
            : MoneyDirection.MONEY_IN);
    const isDocumentAnchored = documentAnchoredSearch !== undefined;
    const suggestedForInvoiceId = documentAnchoredSearch?.suggestedForInvoiceId;

    const transactionFilters = useMemo(
        () => ({
            ...filters,
            direction: transactionDirection,
            // Only txs accrual approve still accepts: already-matched ones
            // show in the matches panel, and a schedule alone doesn't approve
            // a tx, so scheduled payments stay listed.
            ...(isDocumentAnchored ? { isNotAccrualApproved: true } : {}),
        }),
        [filters, transactionDirection, isDocumentAnchored],
    );

    return {
        transactionFilters,
        suggestedForInvoiceId,
        isSearchModePickerVisible: getIsSearchModePickerVisible(
            documentAnchoredSearch,
        ),
    };
}
